import iBnbChain from "./assets/icons/bnb-chain.svg";
import iCsc from "./assets/icons/csc-chain.svg";
import iOkChain from "./assets/icons/okc-chain.svg";
import iPolygon from "./assets/icons/polygon-chain.svg";
import { ChainId, NetworkName, Wallet } from "./enums";
import { ChainConfig } from "./types";
// import iEthereum from "./assets/icons/ethereum-chain.svg";
// import iAvalanche from "./assets/icons/avalanche-chain.svg";

export const chainsConfigProduction: ChainConfig[] = [
  {
    title: NetworkName.BINANCE_MAINNET,
    icon: iBnbChain,
    id: ChainId.BINANCE_MAINNET,
    unsupportedWallets: [],
  },
  // {
  //   title: 'Ethereum',
  //   icon: iEthereum,
  //   chainId: 1
  // unsupportedWallets: []
  // },
  {
    title: NetworkName.CSC_MAINNET,
    icon: iCsc,
    id: ChainId.CSC_MAINNET,
    unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet],
  },
  {
    title: NetworkName.OKC_MAINNET,
    icon: iOkChain,
    id: ChainId.OKC_MAINNET,
    unsupportedWallets: [Wallet.TrustWallet],
  },
  // {
  //   title: 'Avalanche',
  //   icon: iAvalanche,
  //   chainId: 43114
  // unsupportedWallets: []
  // },
  {
    title: NetworkName.POLYGON_MAINNET,
    icon: iPolygon,
    id: ChainId.POLYGON_MAINNET,
    unsupportedWallets: [],
  },
];

export const chainsConfig: ChainConfig[] = [
  {
    title: NetworkName.BINANCE_TESTNET,
    icon: iBnbChain,
    id: ChainId.BINANCE_TESTNET,
    unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet],
  },
  // {
  //   title: 'Ethereum',
  //   icon: iEthereum,
  //   chainId: 1
  // unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet]
  // },
  {
    title: NetworkName.CSC_TESTNET,
    icon: iCsc,
    id: ChainId.CSC_TESTNET,
    unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet],
  },
  {
    title: NetworkName.OKC_TESTNET,
    icon: iOkChain,
    id: ChainId.OKC_TESTNET,
    unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet],
  },
  // {
  //   title: 'Avalanche',
  //   icon: iAvalanche,
  //   chainId: 43114
  // unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet]
  // },
  {
    title: NetworkName.POLYGON_TESTNET,
    icon: iPolygon,
    id: ChainId.POLYGON_TESTNET,
    unsupportedWallets: [Wallet.OKX, Wallet.TrustWallet],
  },
];

const defaultProps = {
  isProduction: process.env.REACT_APP_ENVIRONMENT === "production",
};
/**
 *
 * @param isProduction set to false if testnet config needed
 * @returns array of configs for supported chains
 */
const getChainsConfig = (
  props: {
    isProduction: boolean;
  } = defaultProps
): ChainConfig[] => {
  return props.isProduction ? chainsConfigProduction : [...chainsConfig, ...chainsConfigProduction];
};

export const findChainConfig = (chainId: number): ChainConfig | undefined => {
  const chainsConfig = getChainsConfig();

  return chainsConfig.find(({ id }) => id === chainId);
};

export default getChainsConfig;
